import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import BlogTitle from '../components/BlogTitle';

const GET_BLOG_TITLE = gql`
  query GetBlogTitle {
    currentSite {
      id
      ...BlogTitleCurrentSite
    }
  }

  ${BlogTitle.fragments.currentSite}
`;

const BlogTitleContainer = () => {
  const { data } = useQuery(GET_BLOG_TITLE);

  if (!data) {
    return null;
  }

  const title = data.currentSite?.blogSettings?.title || 'Blog';

  return <BlogTitle title={title} />;
};

export default BlogTitleContainer;
